export default "__VITE_ASSET__D9BFhZJ4__"